import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import { sendApiRequest } from "./requestConfig";
import { findStoreIds } from "./utils";
import { defineSectionNamesForFilter, defineSectionNamesForRegionFilter, defineSectionNamesForNielsenRegionFilter } from "./ReportSettings";

// to save the selected filters for brand report
export const saveBrandFilters = async (campaign_id) => {
  const userStateData = store.getState().userSelections;
  // call api
  const saveFilters = await sendApiRequest(
    "filter/brand-sharing/save",
    {
      ...userStateData.brand_filters,
      campaign: campaign_id,
    },
    "POST"
  );
  //   evaluate api response
  if (typeof saveFilters.success !== "undefined" && saveFilters.success === true) {
    // notify user that filters saved successfully
    toast("Report filters saved successfully", { type: "success" });
    store.dispatch(
      updateStateData({
        report_filter_saved: true,
      })
    );
    return {
      success: true,
    };
  } else {
    // error notification
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};

const defaultDashboardFilter = () => {
  const userStateDetails = store.getState().userSelections;
  const selectedAdlevels = typeof userStateDetails.adlevel_names !== "undefined" && userStateDetails.adlevel_names.length !== 0
    ? [
      // ...["(All)"],
      ...userStateDetails.adlevel_names.map((storeInfo) => {
        return storeInfo.label;
      }),
    ]
    : [];
  const fetchSectionNames = defineSectionNamesForFilter(selectedAdlevels);
  const fetchSectionNamesForRegions = defineSectionNamesForRegionFilter();
  const fetchSectionNamesForNielsenRegions = defineSectionNamesForNielsenRegionFilter();

  return {
    impression_filter: {
      stores:
        userStateDetails.campaign_detail?.campaign_stores?.length > 0
          ? [...userStateDetails.campaign_detail.campaign_stores].sort()
          : [],
      Impression_selected_region_name: typeof userStateDetails.campaign_regions !== "undefined" && userStateDetails.campaign_regions.length !== 0 ? userStateDetails.campaign_regions.map(region => region.label) : [],
      Impression_selected_nielsen_regions: typeof userStateDetails.nielsen_campaign_regions !== "undefined" && userStateDetails.nielsen_campaign_regions.length !== 0 ? userStateDetails.nielsen_campaign_regions.map(region => region.value) : []
    },
    performance_filter: {
      stores:
        userStateDetails.campaign_detail?.campaign_stores?.length > 0
          ? [...userStateDetails.campaign_detail.campaign_stores].sort()
          : [],
      analysis_group: selectedAdlevels,
      ...fetchSectionNames,
      ...fetchSectionNamesForRegions,
      ...fetchSectionNamesForNielsenRegions,
      weeks:
        typeof userStateDetails.campaign_weeks !== "undefined"
          ? [
            // ...["(All)"],
            ...userStateDetails.campaign_weeks
              .map((option) => {
                return parseInt(option.value);
              })
              .sort((next, prev) => {
                return next - prev;
              }),
          ]
          : [],
    },
  };
};

// to fetch the brand report filters saved by retailer/admin
export const fetchBrandFilters = async (campaignid, viewMode) => {
  //Filters should only load AFTER fetch is finished
  store.dispatch(updateStateData({
    brand_filters_loading: true,
    loading: true
  }));
  // const userStateDetails = store.getState().userSelections;
  const fetchFilters = await sendApiRequest("filter/brand-sharing/" + campaignid, {}, "GET");
  let selectionsInfo = {};
  const selectionKeyword = viewMode === "Brand" ? "brand_filters" : "retailer_filters";
  //   evaluate api response
  if (typeof fetchFilters.success !== "undefined" && fetchFilters.success === true) {
    let filterSelections = {};
    // set default filter values if retailer hasn't selected any filter yet
    if (
      typeof fetchFilters.response.impression_filter === "undefined" &&
      typeof fetchFilters.response.performance_filter === "undefined"
    ) {
      filterSelections = defaultDashboardFilter();
      selectionsInfo = {
        brand_filters: { ...fetchFilters.response, ...filterSelections },
        retailer_filters: { ...fetchFilters.response, ...filterSelections },
      }
      // save selected filters to redux, so it will be autofilled in the brand report popup
      // store.dispatch(updateStateData(selectionsInfo));
    } else {
      const fetchSectionNamesForAnalysisGroup = defineSectionNamesForFilter(fetchFilters.response.performance_filter.analysis_group);
      const fetchSectionNamesForRegions = defineSectionNamesForRegionFilter();
      const fetchSectionNamesForNielsenRegions = defineSectionNamesForNielsenRegionFilter();
      selectionsInfo = {
        brand_filters: typeof fetchFilters.response.single_performance_analysis_group !== "undefined" ? fetchFilters.response : {
          ...fetchFilters.response,
          performance_filter: {
            ...fetchFilters.response.performance_filter,
            ...fetchSectionNamesForAnalysisGroup,
            ...fetchSectionNamesForRegions,
            ...fetchSectionNamesForNielsenRegions,
          }
        },
        retailer_filters: defaultDashboardFilter(),
      }
      // save selected filters to redux, so it will be autofilled in the brand report popup
      // store.dispatch(updateStateData(selectionsInfo));
    }

    /*
      => save selected filters to redux, so it will be autofilled in the brand report popup (selectionsInfo)
      => save selections for embeddable dashboard to automatically pick the store values depending on the viewMode
    */

    store.dispatch(updateStateData({
      ...selectionsInfo,
      embedded_impression_filter: {
        ...selectionsInfo[selectionKeyword].impression_filter,
        store_ids:
          typeof selectionsInfo[selectionKeyword].impression_filter.stores !== "undefined" &&
            selectionsInfo[selectionKeyword].impression_filter.stores.length !== 0
            ? findStoreIds([...selectionsInfo[selectionKeyword].impression_filter.stores])
            : [],
        "selected_store_names": [...selectionsInfo[selectionKeyword].impression_filter.stores].map((storeName) => {
          return { value: storeName, label: storeName };
        })
      },
      embedded_performance_filter: {
        ...selectionsInfo[selectionKeyword].performance_filter,
        store_ids:
          typeof selectionsInfo[selectionKeyword].performance_filter.stores !== "undefined" &&
            selectionsInfo[selectionKeyword].performance_filter.stores.length !== 0
            ? findStoreIds([...selectionsInfo[selectionKeyword].performance_filter.stores])
            : [],
        "selected_store_names": [...selectionsInfo[selectionKeyword].performance_filter.stores].map((storeName) => {
          return { value: storeName, label: storeName };
        })
      },
      brand_filters_loading: false,
      loading: false
    }));

    return {
      success: true,
    };
  } else {
    toast("Sorry, something went wrong", { type: "error" });
    return {
      success: false,
    };
  }
};